import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { UserContext } from '../../../auth/models/auth';
import * as menus from '../../../base/actions/menus.actions';
var MegaMenuComponent = /** @class */ (function () {
    function MegaMenuComponent(router, store) {
        var _this = this;
        this.router = router;
        this.store = store;
        this.onToggleNavBar = new EventEmitter();
        this.onToggleMobileUserOptions = new EventEmitter();
        this.onSelectCustomer = new EventEmitter();
        this.onItemClick = new EventEmitter();
        this._topMenus = [];
        this.routerSubscription = this.router.events.pipe(filter(function (ev) { return ev instanceof NavigationStart; })).subscribe(function () {
            _this.closeMegaMenu();
        });
    }
    Object.defineProperty(MegaMenuComponent.prototype, "topMenus", {
        get: function () {
            if (this.menuItems && this.menuItems.length && this._topMenus.length === 0) {
                this._topMenus = this.menuItems
                    .filter(function (menu) { return menu.parent === null; })
                    .map(function (menu) {
                    var topMenu = tslib_1.__assign({}, menu, { isActive: false });
                    return topMenu;
                });
            }
            return this._topMenus;
        },
        enumerable: true,
        configurable: true
    });
    MegaMenuComponent.prototype.ngOnDestroy = function () {
        this.routerSubscription.unsubscribe();
    };
    MegaMenuComponent.prototype.onTopMenuClick = function ($event, menu) {
        if (menu.children && menu.children.length) {
            // Stop default event and propagation for top menu with children clicks. We only need the routerLink on top menus for the routerLinkActive directive to work.
            $event.stopPropagation();
            $event.preventDefault();
            // Close all other mega menus
            this.topMenus
                .filter(function (topMenu) { return topMenu.code !== menu.code; })
                .map(function (topMenu) {
                topMenu.isActive = false;
            });
            menu.isActive = !menu.isActive;
            this.store.dispatch(new menus.ToggleMegaMenu(menu.isActive));
            return false;
        }
    };
    MegaMenuComponent.prototype.hasChildMenus = function (menu) {
        if (menu && menu.children && menu.children.length) {
            return true;
        }
        return false;
    };
    MegaMenuComponent.prototype.getChildMenu = function (childCode) {
        if (this.menuItems && this.menuItems.length) {
            var childMenu = this.menuItems.find(function (menu) { return menu.code === childCode; });
            return childMenu;
        }
    };
    MegaMenuComponent.prototype.closeMegaMenu = function () {
        this.topMenus.forEach(function (menu) { return menu.isActive = false; });
        this.store.dispatch(new menus.ToggleMegaMenu(false));
    };
    MegaMenuComponent.prototype.itemClick = function () {
        this.onItemClick.emit();
    };
    return MegaMenuComponent;
}());
export { MegaMenuComponent };
